const ChevronLGICon = (props) => (
  <svg width="8" height="12" viewBox="0 0 8 12" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <path d="M3.02366 6.00011L7.14866 10.1251L5.97033 11.3034L0.666992 6.00011L5.97033 0.696777L7.14866 1.87511L3.02366 6.00011Z" fill="#616778"/>
  </svg>
);

export default ChevronLGICon;
